import { ItemListType } from '../types/common';

// convertItemListToGeminiPrompt 関数
export const convertItemListToGeminiPrompt = (
  itemList: ItemListType[],
): Record<string, string | Record<string, string>[]> => {
  const result: Record<string, string | Record<string, string>[]> = {};

  // 出力する固定文字列
  const fixedStringValue = '{ text: "string", itemId: [int] }';

  // itemList をループし、親と子を処理
  itemList.forEach(item => {
    const parentValue = item.parentValue;

    // 親の値が null または空文字列の場合はこの親項目をスキップ
    if (parentValue === null || parentValue === '') {
      return; // この親項目はスキップ
    }

    if (item.children && item.children.length > 0) {
      const childObject: Record<string, string> = {};
      let hasValidChildren = false; // 有効な子要素が一つでもあったか追跡するフラグ

      for (const child of item.children) {
        const childValue = child.childValue;

        // 子の値が null または空文字列の場合はこの子項目をスキップ
        if (childValue === null || childValue === '') {
          continue; // この子項目は子オブジェクトに追加しない
        }

        // 子要素オブジェクトにアイテムを追加 (値が有効な場合のみ)
        childObject[childValue] = fixedStringValue;
        hasValidChildren = true; // 有効な子要素が見つかった
      }

      // 有効な子要素が一つもなかった場合、この親項目全体もスキップ
      if (hasValidChildren) {
        // 有効な子項目が一つでもあれば、親のキーと構築した子オブジェクトを追加
        result[parentValue] = [childObject];
      }
    } else {
      // この parent に子要素がない場合
      // シンプルなアイテム構造を作成します。値は固定文字列になります。
      // 親の値は上で null/'' チェック済みなので、ここでは必ず追加されます。
      result[parentValue] = fixedStringValue;
    }
  });

  return result;
};
